import {FormControl} from "react-bootstrap";
import React, {useEffect, useMemo} from "react";

/**
 * @typedef {Object} Option
 * @property {string} key - The unique identifier for the option
 * @property {string} value - The value of the option
 * @property {string?} title - The display title of the option
 */

export const DropDownFieldEditor = (props) => {
	
	const { Value, OnUpdate, FieldDef, CustomData } = props;
	const {
		className = null,
		value = Value,
		onChange = OnUpdate,
		fieldDef = FieldDef,
		filter = (values, selectedValue) => values,
		customData = CustomData,
		context = false,
	} = props;
	
	/** @type {Option[]|string[]|number[]|null} options - Array of objects to be displayed in the dropdown **/
	const optionsFromProps = props?.options ?? customData?.options ?? fieldDef?.customData?.options ?? [];

	// Standardize and memoize the options
	/** @type {Option[]|null} */
	const standardizedOptions = useMemo(() => {
		return optionsFromProps?.map((option) => {
			if (typeof option !== 'object') {
				option = { value: option };
			}
			return {
				key: option.key ?? option.value,
				value: option.value,
				title: option.title ?? option.value,
			};
		})
	}, [optionsFromProps])
	
	let defaultValue = null;
	if (standardizedOptions.find(m => String(m.value) === String(value)) === undefined && standardizedOptions?.[0]?.value != null) {
		defaultValue = String(standardizedOptions[0]?.value);
	}
	
	const filteredOptions = filter([...standardizedOptions], defaultValue);
	
	useEffect(() => {
		if (defaultValue != null && value == null) {
			onChange(defaultValue);
		}
	}, [defaultValue]);
	
	return <FormControl
		as="select"
		className={className}
		value={String(value ?? defaultValue)}
		onChange={x => onChange(x?.target?.value)}
	>
		{
			(standardizedOptions === null) ?
			<option key='0' value='0'>
				Loading...
			</option>
				: null
		}
		{
			filteredOptions?.map(option => {
				return <option key={option?.key ?? option?.value} value={option?.value}>
					{option?.title ?? option?.value}
				</option>;
			}) ?? null
		}
	</FormControl>;
};

